import type { TFunction } from 'i18next';
import { checkKeyExistsInObject } from 'utils';
import enGBResources from 'i18n/translations/en-GB';
import type { getServices_bookableServices } from '../../hooks/useGetServices/__generated__/getServices';
import type { ServiceCardProps, ServiceGroupProps } from '../../components';

const shouldShowGroup = (group: string) => {
  const titleKey = `book.wpo_services.${group}.title`;

  return checkKeyExistsInObject(enGBResources.book, titleKey);
};

const groupServices = (
  services: getServices_bookableServices[],
  t: TFunction<'book'>,
) =>
  services.reduce(
    (acc, service) => {
      const { serviceGroup: group } = service;

      if (!shouldShowGroup(group)) return acc;

      if (!acc[group]) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const title = t(`wpo_services.${group}.title` as any);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const description = t(`wpo_services.${group}.subtitle` as any, '');

        acc[group] = {
          title,
          description,
          group,
          cards: [],
        };
      }

      let cards: ServiceCardProps[] = [
        {
          id: service.id,
          link: `/book/services/${service.serviceSlug}`,
          name: service.name,
        },
      ];

      if (service.expertises && service.expertises.length > 0) {
        cards = service.expertises.map(expertise => ({
          id: expertise.id,
          link: `/book/services/${service.serviceSlug}?expertise=${expertise.id}`,
          name: expertise.name,
        }));
      }

      acc[group].cards.push(...cards);

      return acc;
    },
    {} as Record<string, ServiceGroupProps>,
  );

export default groupServices;
